var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modal)?_c('div',[_c('div',{staticClass:"modal",class:{'big-modal': _vm.modal.isBig}},[_c('button-close',{on:{"close":_vm.close}},[_vm._v(" "+_vm._s(_vm.modal.title)+" ")]),_c('div',{staticClass:"content"},[_c(_vm.modal.component,{tag:"component",attrs:{"modal":_vm.modal}})],1)],1),_c('div',{staticClass:"overlay"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }